webpackJsonp([273950069227526],{

/***/ 783:
/***/ (function(module, exports) {

	module.exports = {"data":{"page":{"id":"/opt/render/project/src/content/pages/1--about/index.md absPath of file >>> MarkdownRemark","html":"<p>We love to travel, we are still figuring out finding time for our travels while keeping our 9-5 jobs! We believe travelling with your kid makes it a lot more fun, and want to inspire others to travel.</p>","frontmatter":{"title":"About"}},"footnote":{"id":"/opt/render/project/src/content/parts/footnote.md absPath of file >>> MarkdownRemark","html":"<ul>\n<li>Pictures are copyrighted by Vivek, Priya</li>\n</ul>"},"site":{"siteMetadata":{"facebook":{"appId":"coralpiyu"}}}},"pathContext":{"slug":"/about/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---about-a632d21c5a03eb87196e.js